import _ from "lodash";

export const navigateToStages = (
  props,
  setInvalidDocumentsError
) => {
  const {
    task,
    taskType,
    queryTemplates,
    setTaskValues,
    setErrorMessage,
    taskValues: {
      stages,
      sections,
      sectionsData,
      currentStage,
      currentSection,
      legalFormalNoticeTemplate,
      options,
      selectedDocuments
    }
  } = props;
  const id = _.get(task, "claimId");
  const currentStageIndex = stages.findIndex(stage => stage === currentStage);
  if (currentStageIndex === 1 && !legalFormalNoticeTemplate) {
    const input = {
      id,
      options,
      documentIds: selectedDocuments.map(doc => doc.id)
    };

    const onSuccess = ({
      receivedGroupData,
      fullPaxFieldsData,
      sectionsData
    }) => {
      const newStages = [
        ...stages.slice(0, 2),
        ...Object.keys(sectionsData),
        ...stages.slice(stages.length - (taskType === "CA" ? 3 : 1))
      ];
      const sections = Object.keys(sectionsData).reduce(
        (prevValue, currValue) => [
          ...prevValue,
          ...Object.keys(sectionsData[currValue])
        ],
        0
      );
      setTaskValues({
        stages: newStages,
        sections,
        sectionsData,
        fullPaxFieldsData,
        currentStage: newStages[2],
        currentSection: sections[0]
      });
    };

    const onError = error => {
      const [message, documents] = _
        .get(error, "networkError.result.message", "")
        .split(":");
      if (
        error.toString().includes("Cannot read property 'value' of undefined")
      ) {
        setErrorMessage("At least one of fields don't exist");
      } else if (message === "Invalid documents") {
        setInvalidDocumentsError(documents, message);
      } else {
        setErrorMessage("There was an error sending query");
      }
    };

    queryTemplates(input, { onSuccess, onError });
  } else {
    const newCurrentSection =
      sections[sections.findIndex(section => section === currentSection) + 1];
    let newCurrentStage = currentStage;
    if (!sectionsData[currentStage][newCurrentSection]) {
      newCurrentStage = stages[currentStageIndex + 1];
    }
    return setTaskValues({
      currentStage: newCurrentStage,
      currentSection: newCurrentSection
    });
  }
};



// WEBPACK FOOTER //
// ./src/component/TaskCreator/NavigationWrapper/navigateToStages.js